import { CheckCircleTwoTone, CloseCircleTwoTone } from '@ant-design/icons';

type Props = { password?: string };

const UserExtraPassword: React.FC<Props> = ({ password }) => {
  if (!password) return null;

  return (
    <small>
      <span>A senha deve conter:</span>
      <ul
        style={{
          padding: 0,
          paddingLeft: 0,
          margin: 0,
          listStyle: 'none',
        }}
      >
        <li>
          {password.length >= 8 ? (
            <CheckCircleTwoTone />
          ) : (
            <CloseCircleTwoTone twoToneColor="red" />
          )}{' '}
          8 ou mais caracteres
        </li>

        <li>
          {/[A-Z]/.test(password) ? (
            <CheckCircleTwoTone />
          ) : (
            <CloseCircleTwoTone twoToneColor="red" />
          )}{' '}
          Letra maiúscula
        </li>

        <li>
          {/[a-z]/.test(password) ? (
            <CheckCircleTwoTone />
          ) : (
            <CloseCircleTwoTone twoToneColor="red" />
          )}{' '}
          Letra minúscula
        </li>
        <li>
          {/[0-9]/.test(password) ? (
            <CheckCircleTwoTone />
          ) : (
            <CloseCircleTwoTone twoToneColor="red" />
          )}{' '}
          Número
        </li>
      </ul>
    </small>
  );
};

export default UserExtraPassword;
